import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { LoadingIndicator } from '@airia/ui';
const COMPACTING_WORDS = [
    'Compressing',
    'Compacting',
    'Squishing',
    'Crunching',
    'Condensing',
    'Folding',
    'Flattening',
    'Distilling',
    'Reducing',
    'Boiling down',
    'Concentrating',
    'Bundling',
    'Deflating',
    'Minifying',
    'Coalescing',
    'Digesting',
    'Crystallizing',
    'Tetris-ing',
    'Marie-Kondo-ing',
];
const getRandomWord = () => COMPACTING_WORDS[Math.floor(Math.random() * COMPACTING_WORDS.length)];
export const CompactingCard = ({ isCompacting }) => {
    const [word, setWord] = useState(getRandomWord);
    useEffect(() => {
        if (!isCompacting)
            return;
        const interval = setInterval(() => {
            setWord(getRandomWord());
        }, 3000);
        return () => clearInterval(interval);
    }, [isCompacting]);
    if (!isCompacting) {
        return null;
    }
    return (_jsx("div", { className: "rounded-lg w-full border border-border bg-muted/30 shadow-sm my-2", children: _jsxs("div", { className: "flex items-center p-3 gap-3", children: [_jsx("div", { className: "w-5 h-5 flex-shrink-0", children: _jsx(LoadingIndicator, { size: "sm" }) }), _jsx("div", { className: "text-sm font-semibold", children: "Excuse us while we tidy up:" }), _jsxs("div", { className: "text-sm text-muted-foreground animate-pulse", children: [word, "..."] })] }) }));
};
